import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const Warehouse = lazy(() => import('../modules/warehouse'));
const WarehouseSection = lazy(
  () => import('../modules/warehouse/pages/WarehouseSection')
);
const WarehouseStock = lazy(
  () => import('../modules/warehouse/pages/WarehouseStock')
);

const WarehouseRoutes = (
  <>
    <Route
      path="warehouse"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Warehouse />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.WAREHOUSE_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <WarehouseSection />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=":id/details"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <WarehouseStock />
          </Suspense>
        }
      />
    </Route>
  </>
);

export default WarehouseRoutes;
